// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__9vNSg","actions":"GroupTable_actions__2qRXV","deleteModalFooter":"GroupTable_deleteModalFooter__3YdoB"};